import { Button, CloseButton, Heading, Modal, TextArea } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import DataGrid from "react-data-grid";

const RaterGrid = ({
  rows,
  setRows,
  cols,
  raterData,
  setRaterData,
  selectedStudent,
  assessorComplete,
  isGradingComplete,
  isExternal,
  hideEvidenceViewer,
}) => {
  const { t } = useTranslation();
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [comment, setComment] = useState("");
  const [selectedSlo, setSelectedSlo] = useState("");

  const handleCellClick = (args) => {
    const { row, column } = args;
    const updatedRows = [...rows];
    let i;
    if (row.id !== "raterRow") {
      const newRaterData = { ...raterData };
      const studentId = isExternal
        ? selectedStudent.canvas_id
        : selectedStudent.id;
      if (
        (!isExternal && !assessorComplete) ||
        (isExternal && !isGradingComplete)
      ) {
        if (
          Object.hasOwn(row, "grading_complete") ? !row.grading_complete : true
        ) {
          rows.forEach((r, index) => {
            if (r.slo === row.slo) {
              i = index;
            }
          });
          if (updatedRows[i][column.key].selected !== undefined) {
            if (updatedRows[i][column.key].selected) {
              updatedRows[i][column.key].selected = false;
              newRaterData[studentId][updatedRows[i].id].score = null;
              setRaterData(newRaterData);
            } else {
              updatedRows[i].na = false;
              updatedRows[i][column.key].selected = true;
              newRaterData[studentId][updatedRows[i].id].score = column.score;
              setRaterData(newRaterData);
            }
            Object.keys(updatedRows[i]).forEach((key) => {
              if (updatedRows[i][key].selected !== undefined) {
                if (updatedRows[i][key] !== updatedRows[i][column.key]) {
                  updatedRows[i][key].selected = false;
                }
              }
            });
          }
        }
        if (column.key === "na") {
          updatedRows[i][column.key] = !updatedRows[i][column.key];
          if (updatedRows[i][column.key]) {
            newRaterData[studentId][updatedRows[i].id].score = "n/a";
            setRaterData(newRaterData);
            Object.keys(updatedRows[i]).forEach((key) => {
              if (updatedRows[i][key].selected !== undefined) {
                updatedRows[i][key].selected = false;
              }
            });
          } else {
            newRaterData[studentId][updatedRows[i].id].score = null;
            setRaterData(newRaterData);
          }
        }
        if (column.key === "comment") {
          setOpenCommentModal(true);
          setSelectedSlo(updatedRows[i].id);
        }
        setRows(JSON.parse(JSON.stringify(updatedRows)));
      }
    }
  };

  const handleClose = () => {
    setOpenCommentModal(false);
    setComment("");
    setSelectedSlo("");
  };

  const handleSubmitComment = () => {
    const newRaterData = { ...raterData };
    const studentId = isExternal
      ? selectedStudent.canvas_id
      : selectedStudent.id;
    newRaterData[studentId][selectedSlo].comment = [
      ...newRaterData[studentId][selectedSlo].comment,
      comment,
    ];
    handleClose();
  };

  const rowHeight = (row) => {
    return row.id === "raterRow" ? 35 : 150;
  };

  const handleCellKeyDown = (args, e) => {
    if (e.key === "Enter") {
      handleCellClick(args);
    }
  };

  return (
    <>
      <DataGrid
        key={`${cols.length}-${hideEvidenceViewer}`}
        className="rdg-light"
        style={{ height: "auto" }}
        rowHeight={rowHeight}
        headerRowHeight={40}
        columns={cols}
        rows={rows}
        onRowsChange={setRows}
        onCellClick={handleCellClick}
        onCellKeyDown={handleCellKeyDown}
        defaultColumnOptions={{ width: "minmax(100px, auto)" }}
      />
      <Modal
        open={openCommentModal}
        onDismiss={handleClose}
        label={t("juriedAssessment.addCommentDialog")}
        size="medium"
      >
        <Modal.Header>
          <CloseButton
            placement="end"
            offset="small"
            onClick={handleClose}
            screenReaderLabel={t("global.close")}
          />
          <Heading as="h3">{t("juriedAssessment.addComment")}</Heading>
        </Modal.Header>
        <Modal.Body>
          <TextArea
            label={t("juriedAssessment.comment")}
            onChange={(e) => setComment(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} margin="0 x-small 0 0">
            {t("global.close")}
          </Button>
          <Button onClick={handleSubmitComment} color="primary">
            {t("global.submit")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RaterGrid;
